import { render, staticRenderFns } from "./UserRecycleBinModal.vue?vue&type=template&id=2221519d&scoped=true"
import script from "./UserRecycleBinModal.vue?vue&type=script&lang=js"
export * from "./UserRecycleBinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221519d",
  null
  
)

export default component.exports